// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Mhq5x","button":"styles_button__snGzp","okayBtn":"styles_okayBtn__3ZDWF","cancelBtn":"styles_cancelBtn__2FXbG","message":"styles_message__GDXnu"};